var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChampionship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 35,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37137 10.0812L5.97944 23.7499H24.0333L25.6413 10.0812L20.629 13.4228L15.0064 5.55106L9.38368 13.4228L4.37137 10.0812ZM3.50722 6.5005L8.75632 9.9999L13.9891 2.67394C14.3904 2.11217 15.1711 1.98206 15.7329 2.38332C15.8451 2.4635 15.9433 2.5617 16.0235 2.67394L21.2564 9.9999L26.5054 6.5005C27.0799 6.11756 27.8559 6.27277 28.2389 6.84719C28.4035 7.09421 28.4749 7.39177 28.4403 7.68661L26.3863 25.146C26.3121 25.7755 25.7786 26.2499 25.1448 26.2499H4.86788C4.23403 26.2499 3.7005 25.7755 3.62644 25.146L1.5724 7.68661C1.49174 7.00099 1.98217 6.37979 2.66779 6.29912C2.96264 6.26444 3.2602 6.33582 3.50722 6.5005ZM15.0064 18.7499C13.6256 18.7499 12.5064 17.6306 12.5064 16.2499C12.5064 14.8691 13.6256 13.7499 15.0064 13.7499C16.387 13.7499 17.5064 14.8691 17.5064 16.2499C17.5064 17.6306 16.387 18.7499 15.0064 18.7499Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionship);
export default __webpack_public_path__ + "static/media/championship.74f4e428e1b6f527b2081e792e833d9e.svg";
export { ForwardRef as ReactComponent };